import { clickAd } from 'player/javascripts/player/advertising'
import { trackElementInteraction } from '../util/analytics'

up.compiler(
  '[data-bottom-video-ad]',
  function (element, { skipAdWaitTimeInSeconds }: { skipAdWaitTimeInSeconds: number }) {
    const closeArea = element.querySelector('.bottom-video-ad--close-area')!
    const closeIcon = closeArea.querySelector('.icon.-close')!
    const playerContainer = element.querySelector('[data-player--container]')!
    const addSkippableClass = '-ad-skippable'
    let countdown: number
    let interval: NodeJS.Timeout

    closeIcon.addEventListener('click', function (event) {
      if (closeArea.classList.contains(addSkippableClass)) {
        trackElementInteraction(element, 'click.bottom_overlay_closed')
        element.remove()
        event.preventDefault()
        event.stopPropagation()
      }
    })

    function updateProgress() {
      if (countdown >= 0) {
        element.style.setProperty(
          '--progress',
          (100 - (countdown / skipAdWaitTimeInSeconds) * 100).toString(),
        )
        --countdown
      } else {
        clearInterval(interval)
        closeArea.classList.add(addSkippableClass)
      }
    }

    function startAnimations() {
      element.style.setProperty('bottom', '0')
      countdown = skipAdWaitTimeInSeconds
      updateProgress()
      interval = setInterval(updateProgress, 1000)
    }

    up.on(playerContainer, 'app:player:adStarted', () => {
      startAnimations()
      up.on(element, 'click', () => {
        clickAd((playerContainer as any).player.videojsPlayer)
      })
    })

    return () => {
      clearInterval(interval)
    }
  },
)
